import Vue from "vue";
import RouterView from "../components/layout/RouterView.vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/downloadurl",
    name: 'downloadurl',
    component: () => import(/* webpackChunkName: "Home" */ "../views/downloadurl.vue")
  },
  {
    path: "/d",
    name: 'd',
    component: () => import(/* webpackChunkName: "Home" */ "../views/downloadurl.vue")
  },
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Home" */ "../views/Home/index.vue")
  },
  {
    path: "/user",
    component: RouterView,
    redirect: "/user/pick",
    children: [
      {
        path: "/user/pick",
        meta: {
          title: "用户取件"
        },
        component: () =>
          import(
            /* webpackChunkName: "userPick"*/ "../views/UserPick/index.vue"
          )
      },
      {
        path: "/user/search-by-code",
        meta: {
          title: "单号查件"
        },
        component: () =>
          import(
            /* webpackChunkName: "userPick"*/ "../views/SeachByCode/index.vue"
          )
      },
      {
        path: "/user/pick-list",
        meta: {
          title: "待取快递"
        },
        component: () =>
          import(
            /* webpackChunkName: "userPick"*/ "../views/UserPickList/index.vue"
          )
      },
      {
        path: "/courier/login",
        meta: {
          title: "投递登录"
        },
        component: () =>
          import(
            /* webpackChunkName: "lgoin"*/
            "../views/Courier/Login.vue"
          )
      },
      {
        path: "/courier/inbound",
        meta: {
          title: "投递"
        },
        component: () =>
          import(
            /* webpackChunkName: "inbound"*/
            "../views/Courier/Inbound.vue"
          )
      },
      {
        path: "/courier/recharge",
        meta: {
          title: "快递员充值"
        },
        component: () =>
          import(
            /* webpackChunkName: "inbound"*/
            "../views/Courier/Recharge.vue"
          )
      },
      {
        path: "/forbiden",
        meta: {
          title: "设备未注册"
        },
        component: () =>
          import(
            /* webpackChunkName: "inbound"*/
            "../views/Forbiden.vue"
          )
      }
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
